import {
  adminClient,
  oneTimeTokenClient,
  organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  plugins: [organizationClient(), adminClient(), oneTimeTokenClient()],
});

export const {
  signIn,
  signUp,
  signOut,
  useSession: useBetterAuthSession,
  organization,
} = authClient;
